module.exports = __webpack_public_path__ + "static/media/Icon-blue-phone.2d0a1ce0.svg";